<mat-toolbar class="main--page-toolbar" color="primary">
  <mat-toolbar-row>
    <img
      src="../../assets/sygnet.svg"
      alt="Application logo"
      style="width: 55px; margin-right: 20px"
    />
    <span>Care Support - Admin Panel</span>
    <span style="flex: 1 1 auto"></span>
    <countdown (event)="handleTimerEvent($event)" #countdown [config]="{ leftTime: 600 } "></countdown>
    <button [matMenuTriggerFor]="menu" mat-icon-button>
      <mat-icon class="main--page-icon">settings</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button (click)="logout()" mat-menu-item>
        <mat-icon>public_off</mat-icon>
        <span>Logout</span>
      </button>
    </mat-menu>
  </mat-toolbar-row>
</mat-toolbar>
<mat-drawer-container class="main--drawer-container">
  <mat-drawer mode="side" opened class="main--drawer-content">
    <a
      class="main--drawer-icon-wrapper"
      [routerLink]="['/main/users']"
      [routerLinkActive]="'main--drawer-active--link'"
      id="usersTab"
    >
      <mat-icon color="primary" class="material-icons main--drawer-icon">
        people
      </mat-icon>
      <p class="navigation-text">Users</p>
    </a>
    <a
      class="main--drawer-icon-wrapper"
      [routerLink]="['/main/admins']"
      [routerLinkActive]="'main--drawer-active--link'"
      id="adminsTab"
    >
      <mat-icon color="primary" class="material-icons main--drawer-icon">
        work
      </mat-icon>
      <p class="navigation-text">Admins</p>
    </a>
    <a
      class="main--drawer-icon-wrapper"
      [routerLink]="['/main/tasks']"
      [routerLinkActive]="'main--drawer-active--link'"
      id="tasksTab"
    >
      <mat-icon color="primary" class="material-icons main--drawer-icon">
        question_answer
      </mat-icon>
      <p class="navigation-text">Tasks</p>
    </a>
    <a
      class="main--drawer-icon-wrapper"
      [routerLink]="['/main/categories']"
      [routerLinkActive]="'main--drawer-active--link'"
      id="categoriesTab"
    >
      <mat-icon color="primary" class="material-icons main--drawer-icon">
        category
      </mat-icon>
      <p class="navigation-text">Categories</p>
    </a>
  </mat-drawer>
  <mat-drawer-content>
    <router-outlet (activate)="handleNavigationChange()"> </router-outlet>
  </mat-drawer-content>
</mat-drawer-container>
